(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPhs(root) {
    if (!root || root.dataset.phsInit === '1') return;
    root.dataset.phsInit = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slides = root.querySelectorAll('[data-phs-slide]');
    var dots = root.querySelectorAll('[data-phs-dot]');
    var prev = root.querySelector('[data-phs-prev]');
    var next = root.querySelector('[data-phs-next]');
    var current = 0;
    var timer = null;
    var seen = false;

    function animateContent(slide) {
      if (reduced) return;
      var items = slide.querySelectorAll('.phs__anim');
      items.forEach(function (el) { el.classList.remove('is-in'); });
      void slide.offsetWidth;
      requestAnimationFrame(function () {
        items.forEach(function (el) { el.classList.add('is-in'); });
      });
    }

    function goTo(index) {
      if (!slides.length) return;
      index = (index + slides.length) % slides.length;
      if (index === current && slides[index].classList.contains('is-active') && seen) return;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      current = index;
      animateContent(slides[index]);
    }

    function startAutoplay() {
      if (root.dataset.autoplay !== 'true' || slides.length < 2 || reduced) return;
      stopAutoplay();
      timer = setInterval(function () { goTo(current + 1); }, parseInt(root.dataset.speed, 10) || 5000);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    var touchX = null;
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 50) goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });

    if (reduced || !('IntersectionObserver' in window)) {
      seen = true;
      root.querySelectorAll('.phs__anim').forEach(function (el) { el.classList.add('is-in'); });
      startAutoplay();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || seen) return;
          seen = true;
          io.unobserve(root);
          animateContent(slides[current]);
          startAutoplay();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    }

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('[data-phs-slide]') : null;
      if (!slide || !root.contains(slide)) return;
      stopAutoplay();
      goTo(Array.prototype.indexOf.call(slides, slide));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-phs]').forEach(initPhs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPtl(root) {
    if (!root || root.dataset.ptlInit === '1') return;
    root.dataset.ptlInit = '1';
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var anims = root.querySelectorAll('.ptl__anim');
    var timeline = root.querySelector('[data-ptl-timeline]');
    var fill = root.querySelector('[data-ptl-fill]');
    var steps = root.querySelectorAll('[data-ptl-step]');

    if (reduced || !('IntersectionObserver' in window)) {
      anims.forEach(function (el) { el.classList.add('is-in'); });
      steps.forEach(function (s) { s.classList.add('is-on'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15 });
    anims.forEach(function (el) { io.observe(el); });

    if (!timeline || !fill) return;
    var ticking = false;

    function update() {
      ticking = false;
      var rect = timeline.getBoundingClientRect();
      var marker = window.innerHeight * 0.6;
      var progress = (marker - rect.top) / rect.height;
      progress = Math.max(0, Math.min(1, progress));
      fill.style.height = (progress * 100) + '%';
      var fillY = rect.top + rect.height * progress;
      steps.forEach(function (step) {
        var sr = step.getBoundingClientRect();
        step.classList.toggle('is-on', sr.top + 10 <= fillY);
      });
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    var watching = false;
    var visIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !watching) {
          watching = true;
          window.addEventListener('scroll', onScroll, { passive: true });
          update();
        } else if (!entry.isIntersecting && watching) {
          watching = false;
          window.removeEventListener('scroll', onScroll);
        }
      });
    }, { rootMargin: '80px 0px 80px 0px' });
    visIo.observe(timeline);
  }

  function initAll() {
    document.querySelectorAll('[data-ptl]').forEach(initPtl);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
